import type { PersonalAccountMenuFindInterface } from '@zaoblako/shared/modules/security/dtos/personal-account/menu/personal-account-menu-find.dto';
import type { PersonalAccountMenuFormInterface } from '@zaoblako/shared/modules/security/dtos/personal-account/menu/personal-account-menu-form.dto';

import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';

/** Provides personal account mode menu reading and writing */
@Injectable({ providedIn: 'root' })
export class PersonalAccountMenuService {
  private readonly http = inject(HttpClient);

  private readonly baseUrl = '/basis/client/personal-account-menu';

  /**
   * Get personal account mode menu
   *
   * @returns `Observable` with menu tree
   */
  public getMenu(): Observable<PersonalAccountMenuFindInterface> {
    return this.http.get<PersonalAccountMenuFindInterface>(this.baseUrl);
  }

  /**
   * Set personal account mode menu
   *
   * @param body New menu
   *
   * @returns `Observable` with updated menu tree
   */
  public setMenu(body: PersonalAccountMenuFormInterface): Observable<PersonalAccountMenuFindInterface> {
    return this.http.put<PersonalAccountMenuFindInterface>(this.baseUrl, body);
  }
}
